import React from "react";
import { Styled } from "./styles";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import CategoriesOverview from "@/components/category";
import { useQueryCategory } from "@/hooks/queries/useQueryCategory";
import { CircularProgress } from "@mui/material";

const Category: React.FC = () => {
    const { data, isLoading } = useQueryCategory();

    if (isLoading || !data) {
        return (
            <Styled.Page center={true}>
                <CircularProgress />
            </Styled.Page>
        );
    }

    return (
        <Styled.Page>
            <CategoriesOverview data={data} />
        </Styled.Page>
    );
};

export default withErrorBoundary({ component: "Category Page" })(Category);
